import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { VendorContainerModel } from '../../../../../models/aggregates/vendor/vendor-container.model';


// https://api.akaun.cloud/core2/tnt/dm/vendors/login-tenant-ep/

@Injectable({
  providedIn: 'root'
})
export class VendorLoginTenantEpService extends BaseApiTemplateService<VendorContainerModel> {
  protected apiUrl: string;

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'vendors/login-tenant-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'vendors/login-tenant-ep';
    this.httpClient = http;
  }
}
